export enum DATA_QA {
  ROOT = 'dnc-name-input',
  INPUT = 'dnc-name-input__input',
  CHARACTER_COUNT = 'dnc-name-input__character-count',
  INPUT_ERROR = 'dt-input-error',
}
